import { Box } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import Syllabus from 'modules/trainings/components/content/Syllabus'

export default function ContentOverviewPage() {
  const { trainingId } = useStrictParams<'trainingId'>()
  const { employee: currentEmployee } = useCurrentSession()
  return (
    <Box gap="s8">
      <Syllabus trainingId={Number(trainingId)} employeeId={currentEmployee.id} />
    </Box>
  )
}
